 <template>
  <div>
    <div>
      <form class="form-signin" role="form" @submit.prevent="onLogin">
        <div class="form-group">
          <h2>Login</h2>
        </div>
        <div v-if="isErr.length" class="alert alert-danger">{{ isErr }}</div>
        <div v-if="mfaStep!=true">
          <div class="form-group">
            <label class="control-label" for="signupEmail">Email</label>
            <input
              id="signupEmail"
              required
              type="email"
              maxlength="100"
              class="form-control"
              v-model="email"
            />
          </div>

          <div class="form-group">
            <label class="control-label" for="signupPassword">Password</label>
            <input
              class="form-control"
              id="signupPassword"
              type="password"
              required
              autocomplete="off"
              v-model="password"
            />
          </div>
          <div class="form-group">
            <button id="signupSubmit" @submit="onLogin" class="btn btn-info btn-block">Login</button>
          </div>

          <hr />
          <p>
            <a>
              <router-link to="/register">
                <i class="fa fa-fw fa-group"></i> Register
              </router-link>
            </a>
            <a>
              <router-link to="/forgotPassword">
                <i class="fa fa-fw fa-group"></i> Forgot Password?
              </router-link>
            </a>
            <br />
            <a>
              <router-link to="/resendCode">
                <i class="fa fa-fw fa-group"></i> Resend Confirmation Code
              </router-link>
            </a>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

 <style lang="css" scoped>
</style>

 <script>
import { mapState } from "vuex";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      email: "",
      password: "",
      errorMessage: null,
      mfaStep: false,
      mfaData: {
        destination: "",
        callback: null
      }
    };
  },
  computed: {
    ...mapState(["loginError", "user"]),
    isErr: function() {
      return this.loginError;
    },
    isLoggedIn: {
      get: function() {
        return this.user;
      }
    }
  },
  methods: {
    async onLogin() {
      let email = this.email;
      let password = this.password;
      let store = this.$store;
      let router = this.$router;

      // if we've got a user, send to secure
      if (store.state.user != null) {
        // send to secure home
        router.push({ name: "SecureHome" });
      } else {
        // login the user
        await store.dispatch("login", { email, password });

        // after we get the promise back,
        //if we've got a user, send to secure
        if (store.state.user) {
          router.push({ name: "SecureHome" });
        }
      }
    }
  }
};
</script>